module.exports = __webpack_public_path__ + "static/img/rail-text-4.ceb42e64.png";